document.addEventListener('click', (e) => {
  const footerLink = e.target.closest('a[href="#custom-footer-id"]');
  if (!footerLink) return;

  e.preventDefault();

  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  document.documentElement.classList.remove('m2a');

  const footer = document.querySelector('#custom-item-menu');
  if (footer) {
    const footerRect = footer.getBoundingClientRect();
    const footerHeight = footerRect.height;
    const viewportHeight = window.innerHeight;

    const scrollTop = window.pageYOffset + footerRect.top - (viewportHeight / 2) + (footerHeight / 2);

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth'
    });
  }
});
